import Result from './src/result.vue';

export default Result;
